import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import ManageAlertsContent from "components/pages/AdvancedAlertsPage/components/ManageAlertsContent";
import Classes, { Account } from "model";

export default function CaptureNotifiLegacyAddedSuccessfully(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    const dataObj = { added: true };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], ManageAlertsContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}